import type { ReactNode } from 'react';

export const symbol_bike_dock: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M148-120q-12 0-20-9.5t-8-22.5q0-13 8.5-22.5T150-187l167-43 57-556q2-23 19.5-38.5T434-840h91q23 0 40.5 15.5T585-786l58 556 165 42q14 4 23 13t9 23q0 13-8.5 22.5T810-120H148Zm292-100h80v-520q0-17-11.5-28.5T480-780q-17 0-28.5 11.5T440-740v520Z"
		/>
	</svg>
);
